import moment from 'moment';
import React from 'react';
import Page from '../../components/Page';
import { useConfigDataState } from '../../globalStates/ConfigDataState';
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState';
import { useLanguageState } from "../../globalStates/LanguageState";
import { compareDates, now } from '../../utils/Dates';
import AddressSection from './AddressSection';
import AdsSection from './AdsSection';
import CompanyDescriptionSection from './CompanyDescriptionSection';
import CompanyNameSection from './CompanyNameSection';
import CompanySortSection from './CompanySortSection';
import ContactSection from './ContactSection';
import LogoBackgroundImageSection from './LogoBackgroundImageSection';
import { hasServiceKeys } from '../../globalStates/ConfigDataState';

const PrintPage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const serviceKeys = useConfigDataState().getServiceKeys()
    const logoVisible =
        hasServiceKeys(serviceKeys.printLogo)
        || hasServiceKeys(serviceKeys.printLogoExhibitorDirectory)
        || hasServiceKeys(serviceKeys.printLogoCategoryDirectory)
    const companyNameVisible = hasServiceKeys(serviceKeys.printOrganizationName)
    const addressVisible =
        hasServiceKeys(serviceKeys.printAddress)
        || hasServiceKeys(serviceKeys.printAddressCategoryDirectory)
    const contactVisible =
        hasServiceKeys(serviceKeys.printContact)
        || hasServiceKeys(serviceKeys.printContactCategoryDirectory)
    const descriprionVisible = hasServiceKeys(serviceKeys.printDescription)
    const adsVisible = hasServiceKeys(serviceKeys.printAd)
    const printCatalogsState = useExhibitorDataState().getPrintCatalog()
    const organizationState = useExhibitorDataState().getOrganization()
    const deadline = branding.configuration.printPage.deadLine && moment(branding.configuration.printPage.deadLine).toDate()
    const readOnly = !!(deadline && (compareDates(deadline, now()) < 0))

    return (
        <Page
            title={branding.configuration.printPage.pageTitle}
            description={branding.configuration.printPage.pageDescription}>
            {logoVisible && <LogoBackgroundImageSection printCatalogState={printCatalogsState} readOnly={readOnly} />}
            {companyNameVisible && <CompanyNameSection printCatalogState={printCatalogsState} organizationState={organizationState} readOnly={readOnly} />}
            <CompanySortSection organizationState={organizationState} />
            {addressVisible && <AddressSection printCatalogState={printCatalogsState} organizationState={organizationState} readOnly={readOnly} />}
            {contactVisible && <ContactSection printCatalogState={printCatalogsState} organizationState={organizationState} readOnly={readOnly} />}
            {descriprionVisible && <CompanyDescriptionSection printCatalogState={printCatalogsState} organizationState={organizationState} readOnly={readOnly} />}
            {adsVisible && <AdsSection adStates={printCatalogsState.adPages} readOnly={readOnly} />}
        </Page>
    );
}

export default PrintPage
